import type { DynamicFieldComponentProps } from '../dynamic-form/dynamic-form.interfaces';
import ErrorLabel from './error-label';
import FieldLabel from './field-label';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import useDOMPurify from '../../common/hooks/use-dom-purify';

export default function DataLabel({ label, value, error, labelStyles }: DynamicFieldComponentProps<string>) {
  const { sanitize } = useDOMPurify();
  const [sanitizedValue, setSanitizedValue] = useState('');

  useEffect(() => {
    setSanitizedValue(sanitize(value ?? ''));
  }, [value, sanitize]);

  const valueStyles = clsx('odin-text-sm [&_a]:odin-underline [&_a]:odin-text-url');

  return (
    <>
      {label && <FieldLabel label={label} labelStyles={labelStyles} />}
      {value && <div className={valueStyles} dangerouslySetInnerHTML={{ __html: sanitizedValue }} />}
      {error && <ErrorLabel>{error}</ErrorLabel>}
    </>
  );
}
